const ConnectionStatus = {
    Connected: 'Connected',
    NotConnected: 'NotConnected',
};
export default ConnectionStatus;
